module.exports = __webpack_public_path__ + "img/icon05.1669721740000.png";